import * as React from "react";

const SvgIcnFilterTrigger = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g transform="translate(0 -4)" fill="currentColor" stroke="none" strokeWidth={1} fillRule="evenodd">
            <rect x={6} y={12} width={12} height={1} rx={0.5} />
            <rect x={8} y={15} width={8} height={1} rx={0.5} />
            <rect x={10} y={18} width={4} height={1} rx={0.5} />
        </g>
    </svg>
);

export default SvgIcnFilterTrigger;
